import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import contentApi from "../../services/contentApi";
import { canManageContent } from "./contentAccess";
import "./ContentLogin.css";

const safeAdminPath = (value) =>
  typeof value === "string" && value.startsWith("/content-admin") && !value.startsWith("//")
    ? value
    : "/content-admin/blog";

const ContentLogin = () => {
  const [cookies, setCookie, removeCookie] = useCookies(["mytoken"]);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const destination = safeAdminPath(location.state?.from);

  useEffect(() => {
    if (!cookies.mytoken || cookies.mytoken === "undefined") return undefined;
    let current = true;
    setStatus("checking");
    contentApi.getProfile(cookies.mytoken).then((profile) => {
      if (!current) return;
      if (canManageContent(profile)) navigate(destination, { replace: true });
      else {
        setStatus("idle");
        setMessage("This account does not have insurance content access.");
      }
    }).catch((error) => {
      if (!current) return;
      if (error?.status === 401) removeCookie("mytoken", { path: "/" });
      setStatus("idle");
    });
    return () => { current = false; };
  }, [cookies.mytoken, destination, navigate, removeCookie]);

  const submit = async (event) => {
    event.preventDefault();
    if (status === "submitting") return;
    setMessage("");
    setStatus("submitting");
    try {
      const response = await contentApi.login({ username: username.trim(), password });
      if (!response?.token) throw new Error("The server did not return a login token.");
      const profile = await contentApi.getProfile(response.token);
      if (!canManageContent(profile)) {
        setMessage("This account does not have insurance content access.");
        setStatus("idle");
        return;
      }
      setCookie("mytoken", response.token, {
        path: "/",
        sameSite: "lax",
        ...(window.location.protocol === "https:" ? { secure: true } : {}),
      });
      navigate(destination, { replace: true });
    } catch (error) {
      setMessage(error?.status === 400 || error?.status === 401 ? "Invalid username or password." : error?.message || "Sign in is unavailable right now.");
      setStatus("idle");
    }
  };

  return <main className="content-login-page">
    <section className="content-login-card" aria-labelledby="content-login-title">
      <div className="content-login-brand"><Link to="/">Thrive Insurance</Link><span>Content Studio</span><h1 id="content-login-title">Insurance stories start here.</h1><p>Create trusted guidance, publish updates, and understand what readers value.</p></div>
      <form onSubmit={submit} noValidate><div><p>Team access</p><h2>Sign in</h2><span>Use your assigned content manager or administrator account.</span></div>{message && <div className="content-login-error" role="alert"><i className="fas fa-circle-exclamation" aria-hidden="true" /> {message}</div>}<label><span>Username</span><input type="text" autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)} required autoFocus /></label><label><span>Password</span><div className="content-login-password"><input type={showPassword ? "text" : "password"} autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required /><button type="button" aria-label={showPassword ? "Hide password" : "Show password"} onClick={() => setShowPassword((value) => !value)}><i className={`far fa-eye${showPassword ? "-slash" : ""}`} aria-hidden="true" /></button></div></label><button className="content-login-submit" type="submit" disabled={status === "submitting" || status === "checking"}>{status === "submitting" || status === "checking" ? "Checking access..." : "Open Content Studio"}</button><Link className="content-login-back" to="/">Back to public website</Link></form>
    </section>
  </main>;
};

export default ContentLogin;
